import { render, staticRenderFns } from "./AdminMetricStrip.vue?vue&type=template&id=f135aaf0&scoped=true&"
import script from "./AdminMetricStrip.vue?vue&type=script&lang=js&"
export * from "./AdminMetricStrip.vue?vue&type=script&lang=js&"
import style0 from "./AdminMetricStrip.vue?vue&type=style&index=0&id=f135aaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f135aaf0",
  null
  
)

export default component.exports